<template>
    <div class="flex flex-col pb-2">
        <div class="flex w-full justify-between">
            <div class="whitespace-prewrap font-semibold tracking-wide  text-gray-800 pr-0">
                Start Date:
            </div>
            <div class="border-b-2 border-dotted border-gray-400 flex-grow mb-2 mx-1"></div>
            <div class="pl-0">
                {{ startDate }}
            </div>
        </div>
        <div class="flex w-full justify-between">
            <div class="whitespace-prewrap font-semibold tracking-wide  text-gray-800 pr-0">
                End Date:
            </div>
            <div class="border-b-2 border-dotted border-gray-400 flex-grow mb-2 mx-1"></div>
            <div class="pl-0">
                {{ endDate }}
            </div>
        </div>
        <div class="flex w-full justify-between">
            <div class="whitespace-prewrap font-semibold tracking-wide  text-gray-800 pr-0">
                Retainer Status:
            </div>
            <div class="border-b-2 border-dotted border-gray-400 flex-grow mb-2 mx-1"></div>
            <div class="pl-0">
                {{ retainerStatus }}
            </div>
        </div>
        <div class="flex w-full justify-between">
            <div class="whitespace-prewrap font-semibold tracking-wide  text-gray-800 pr-0">
                Retainer:
            </div>
            <div class="border-b-2 border-dotted border-gray-400 flex-grow mb-2 mx-1"></div>
            <div class="pl-0">
                {{ retainerAmount }}
            </div>
        </div>
        <div class="flex w-full justify-between">
            <div class="whitespace-prewrap font-semibold tracking-wide  text-gray-800 pr-0">
                Tail Start Date:
            </div>
            <div class="border-b-2 border-dotted border-gray-400 flex-grow mb-2 mx-1"></div>
            <div class="pl-0">
                {{ tailStartDate }}
            </div>
        </div>
        <div class="flex w-full justify-between">
            <div class="whitespace-prewrap font-semibold tracking-wide  text-gray-800 pr-0">
                Tail End Date:
            </div>
            <div class="border-b-2 border-dotted border-gray-400 flex-grow mb-2 mx-1"></div>
            <div class="pl-0">
                {{ tailEndDate }}
            </div>
        </div>
        <!-- <div class="flex w-full justify-between">
            <div class="whitespace-prewrap font-semibold tracking-wide  text-gray-800 pr-0">
                Next Invoice Day:
            </div>
            <div class="border-b-2 border-dotted border-gray-400 flex-grow mb-2 mx-1"></div>
            <div class="pl-0">
                {{ targetDueDay }}
            </div>
        </div> -->
        <!-- <div class="flex w-full justify-between">
            <div class="whitespace-prewrap font-semibold tracking-wide  text-gray-800 pr-0">
                Days Until Next Invoice Day:
            </div>
            <div class="border-b-2 border-dotted border-gray-400 flex-grow mb-2 mx-1"></div>
            <div :class="dateStyling">
                {{ engagement.days_until_target_invoice_day }}
            </div>
        </div> -->
        <!-- <div class="flex w-full justify-between">
            <div class="whitespace-prewrap font-semibold tracking-wide  text-gray-800 pr-0">
                Target Due Date:
            </div>
            <div class="border-b-2 border-dotted border-gray-400 flex-grow mb-2 mx-1"></div>
            <div >
                {{ targetDueDate }}
            </div>
        </div>
        <div class="flex w-full justify-between">
            <div class="whitespace-prewrap font-semibold tracking-wide  text-gray-800 pr-0">
                Last Invoice Sent (Due):
            </div>
            <div class="border-b-2 border-dotted border-gray-400 flex-grow mb-2 mx-1"></div>
            <div @click="showAllInvoices"  v-if="mostRecentInvoice">
                <span class="underline hover:cursor-pointer">{{ mostRecentInvoice.invoice_number }}:</span> {{ formatDateTwoDigitYear(mostRecentInvoice.invoice_date) }} ({{ formatDateMonthAndDay(mostRecentInvoice.due_date) }})
            </div>
        <base-modal 
        :is-form-visible="viewAllInvoices" @close="closeAllInvoices"
            >
              <template v-slot:header>
                Retainer Invoices for {{ client.client_name }}:
              </template>
              <template v-slot:body>
                <div class="max-h-[95vh] overflow-auto">
                    <SimpleInvoiceTable :invoices="engagement.invoices" />
                </div>
              </template>
        </base-modal>
        </div> -->
    </div>
</template>

<script setup>
import { defineProps, ref, computed } from 'vue';
import { formatDateTwoDigitYear, formatDateWithWeekday, formatDateMonthAndDay } from '@/composables/formatDate';
import { formatCurrency } from '@/composables/formatCurrency';
import SimpleInvoiceTable from '../invoice_components/SimpleInvoiceTable.vue';

const props = defineProps([
    'engagement',
    'client'
])

const startDate = computed(() => {
    return formatDateTwoDigitYear(props.engagement.start_date)
})

const endDate = computed(() => {
    return formatDateTwoDigitYear(props.engagement.end_date)
})

const tailStartDate = computed(() => {
    return formatDateTwoDigitYear(props.engagement.tail_start_date)
})

const tailEndDate = computed(() => {
    return formatDateTwoDigitYear(props.engagement.tail_end_date)
})

const retainerAmount = computed(() => {
    return formatCurrency(props.engagement.retainer_amount)
})

const retainerStatus = computed(() => {
    return props.engagement.retainer_on ? "On" : "Off"
})

const viewAllInvoices = ref(false)


function showAllInvoices(){
    viewAllInvoices.value = true
}

function closeAllInvoices(){
    viewAllInvoices.value = false
}

const targetDueDay = computed(() => {
    if(props.engagement.target_invoice_day){
        return formatDateWithWeekday(props.engagement.target_invoice_day.target_day.replace(/-/g, '/'))
    } else {
        return "--"
    }
})


</script>